import axios from 'axios';

const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
  data() {
    return {
      user: {
        phone: '',
        phone_mobile: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        address: '',
        checkedRules: false,
        checkedPers: false,
        is_master: true,
        birthday_on_local: null,
        gender: null,
        master_ids: [],
      },
      pageRules: {
        title: 'Тайтл соглашения',
        content: 'Подтверждение согласия на обработку ПД',
      },
      pagePers: {
        title: 'Тайтл соглашения',
        content: 'Согласие с правилами мотивационной программы',
      },
      dialogRules: false,
      dialogPers: false,
      code: '',
      sentCode: false,
      token: '',
      hidePw: true,
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        email: v => pattern.test(v) || 'Поле E-mail заполнено с ошибками',
        password: v => !!v || 'Укажите пароль',
        phone: v => (!v || !v.length || v.length >= 17) || 'Номер телефона заполнен не полностью',
        code: v => !!v || 'Укажите проверочный код',
      },
      valid: false,
      profile: {},
      searchCity: '',
      cities: [],
      selectedCity: null,
      searchPoint: '',
      points: [],
      selectedPoint: null,
      searchAddress: '',
      addresses: [],
      selectedAddress: null,
      rtt_name_legal: '',
      rtt_name_fact: '',
      itemSex: [
        {
          value: 'male',
          text: 'Мужской',
        },
        {
          value: 'female',
          text: 'Женский',
        },
      ],
    };
  },
  computed: {
    requireRules() {
      return this.$store.state.settings.register_rules === true;
    },
    requirePers() {
      return this.$store.state.settings.register_pers === true;
    },
    type() {
      if (this.$store.state.settings.registration === 'unregistered_by_phone') {
        return 'sms_noprofile_or_unregistered';
      }
      if (this.$store.state.settings.registration === 'existing_by_phone') {
        return 'sms_profile_unregistered';
      }
      if (this.$store.state.settings.registration === 'free_by_phone') {
        return 'sms_noprofile';
      }
      if (this.settings && this.settings.registration === 'free_by_email') {
        return 'email_noprofile';
      }
      return null;
    },
    isSmsNoProfile() { return this.type === 'sms_noprofile'; },
    isEmailNoProfile() { return this.type === 'email_noprofile'; },
    comparePasswords() {
      return this.user.password === this.user.passwordConfirm ? true : 'Пароли не совпадают';
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
    phoneMask() {
      return this.user.phone_mobile[0] === '8' ? '8 (###) ###-####' : '+7 (###) ###-####';
    },
  },
  methods: {
    SetAddress() {
      if (this.selectedAddress && this.selectedAddress.id) {
        this.user.sales_point_address_id = this.selectedAddress.id;
        this.rtt_name_fact = this.selectedAddress.sales_point_fact.name;
        this.rtt_name_legal = this.selectedAddress.sales_point_legal.name;
      } else {
        this.rtt_name_fact = null;
        this.rtt_name_legal = null;
      }
    },
    SetCity() {
      if (this.selectedCity && this.selectedCity.city_id) {
        this.user.city_id = this.selectedCity.city_id;
      }
    },
    ChangeCity(e) {
      if (e) {
        this.getAddress(e.city_id);
      } else {
        this.addresses = [];
      }
    },
    getAddress(id) {
      const app = this;
      if (app.selectedCity) {
        this.$store.getters.ax.post('profiles/api/register/load-address', { city_id: id })
          .then((result) => {
            app.addresses = result.data.addresses;
          });
      }
    },
    /** Предзагрузка данных в форму если участник добавлен в админке */
    LoadRegInfo() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/register/info', { phone: app.user.phone_mobile })
        .then((response) => {
          app.pagePers = response.data.pagePers;
          app.pageRules = response.data.pageRules;
          const { profile } = response.data;
          if (profile) {
            app.user.first_name = profile.first_name;
            app.user.last_name = profile.last_name;
            app.user.middle_name = profile.middle_name;
            app.user.email = profile.email;
          }
        });
    },
    /** Фокус на указанное поле */
    Focus(id) {
      this.$nextTick(() => {
        document.getElementById(id).focus();
      });
    },
    /** Сброс полей формы */
    Reset() {
      this.user = {
        phone: '',
        phone_mobile: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        address: '',
        checkedRules: false,
        checkedPers: false,
        is_master: true,
        birthday_on_local: null,
        gender: null,
        master_ids: [],

      };
      this.sentCode = false;
      this.code = '';
      this.token = null;
      this.dialogRules = false;
      this.dialogPers = false;
      this.searchCity = '';
      this.cities = [];
      this.selectedCity = null;
      this.searchPoint = '';
      this.points = [];
      this.selectedPoint = null;
      this.searchAddress = '';
      this.addresses = [];
      this.selectedAddress = null;

      this.Focus('regPhone');
    },
    /** Отправка проверочного СМС кода */
    SendCode() {
      const app = this;
      let url = 'api/token/get-email';
      const data = { type: app.type };
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsNoProfile) {
        url = 'profiles/api/token/get-sms';
        data.phone = app.user.phone_mobile;
      }
      app.$store.getters.axl.post(url, data)
        .then(() => {
          app.sentCode = true;
          app.Focus('regCode');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regPhone');
        });
    },
    /** Проверка кода полученного в СМС */
    CheckCode() {
      const app = this;
      let url = 'profiles/api/token/check-email';
      const data = { type: app.type, code: app.code };
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsNoProfile) {
        url = 'profiles/api/token/check-sms';
        data.phone = app.user.phone_mobile;
      }
      app.$store.getters.axl.post(url, data)
        .then((response) => {
          app.token = response.data.token;
          app.Focus('password');
          app.LoadRegInfo();
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regCode');
        });
    },
    /** Отправка регистрационных данных в приложение */
    Register() {
      const app = this;
      const formData = { ...app.user };
      formData.token = app.token;
      if (!app.requireRules) {
        formData.checkedRules = true;
      }
      if (!app.requirePers) {
        formData.checkedPers = true;
      }

      if (!app.user.is_master) {
        formData.companies_new_masters = [];
        formData.companies_exist_masters = [];

        this.masters.forEach((item) => {
          if (item.master === 'new') {
            formData.companies_new_masters.push(item.company);
          } else {
            formData.companies_exist_masters.push(item.company);
          }
        });
      }
      app.$store.getters.axl.post('profiles/api/register', formData)
        .then((response) => {
          app.$store.commit('SetLogged', response.data);
          app.Reset();
          app.$store.dispatch('ShowInfo', 'Добро пожаловать в программу!');
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    async AutocompleteSearch(queryString) {
      queryString = this.search;
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      this.isLoadingSuggest = true;
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      await axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
        })
        .catch((err) => {
          console.log(err);
        }).finally(() => {
          this.isLoadingSuggest = false;
        });
    },
    AutocompleteSelect(item) {
      this.suggestions.forEach((sug) => {
        if (sug.value === item.value) {
          this.profile.address = sug.data;
          document.getElementById('address').focus();
        }
      });
    },
    addMaster() {
      this.masters.push({
        searchCompanies: '',
        searchMaster: '',
        company: '',
        masters: [],
        companies: [],
        master: '',
      });
    },
    deleteMaster(index) {
      this.masters = this.masters.filter((item, ind) => ind !== index);
    },
  },
  watch: {
    searchCity(city) {
      const app = this;
      if (city && city.length) {
        app.$store.getters.ax.post('profiles/api/register/cities-list', { term: city })
          .then((result) => {
            app.cities = result.data.cities;
          });
      }
    },
    searchAddress() {
      if (this.selectedCity) {
        this.getAddress(this.selectedCity.city_id);
      }
    },
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
    this.$store.dispatch('GetSettings');
    this.Focus('regPhone');
  },
};
